import { Link } from 'react-router-dom';

import styles from './styles.module.css';

import { TaxSortedPerStructure } from '../../TaxOptimisation';
import BooleanImage from '../../../../components/BooleanImage/BooleanImage';
import { useEffect, useState } from 'react';
import { Countries, TCountryCode } from '../../../../types/general';
import React from 'react';

interface ContentProps {
    data: TaxSortedPerStructure;
    img: string;
    name: string;
    isOpen: boolean;
    collapsedOpenEnded: boolean | string | undefined;
    collapsedLegalType: string | undefined;
    collapsedFund?: string | undefined;
    collapsedOpenDomicile: string | undefined | Array<string>;
    stackItems?: number;
}

interface TaxBoxProps extends ContentProps {
    link: string;
    isSelecting?: boolean;
    isSelected?: boolean;
    handleSelect?: (data: TaxSortedPerStructure) => void;
    stackItems?: number;
    onClick?: any;
    hasLink?: boolean;
}

const TaxBox = ({
    data,
    img,
    name,
    link,
    isOpen,
    collapsedOpenEnded,
    collapsedLegalType,
    collapsedFund,
    collapsedOpenDomicile,
    isSelecting,
    isSelected,
    handleSelect,
    stackItems,
    onClick,
    hasLink = true,
}: TaxBoxProps) => {
    const [domicile, setDomicile] = useState('');

    const handleClick = () => {
        if (isSelecting && handleSelect) {
            handleSelect(data);
        }
        onClick && onClick();
    };

    useEffect(() => {
        setDomicile(typeof collapsedOpenDomicile === 'object' ? collapsedOpenDomicile[0] : collapsedOpenDomicile || '');
    }, [collapsedOpenDomicile]);

    const Content = ({
        data,
        img,
        name,
        isOpen,
        collapsedOpenEnded,
        collapsedLegalType,
        collapsedFund,
        collapsedOpenDomicile,
        stackItems,
    }: ContentProps) => (
        <>
            <div
                className={`${styles.stack} ${styles.imgWrapper}`}
                style={
                    {
                        '--total': stackItems || 0,
                    } as React.CSSProperties
                }
            >
                {stackItems && (
                    <>
                        {/*<div className={styles.stack}>*/}
                        {Array.from({ length: stackItems }).map((_, i) => (
                            <div
                                key={i}
                                className={styles.stackItem}
                                style={
                                    {
                                        '--i': i,
                                    } as React.CSSProperties
                                }
                            >
                                <div className={styles.stackItemInner}></div>
                            </div>
                        ))}
                        {/*</div>*/}
                    </>
                )}

                <div
                    className={`${styles.stackItem}`}
                    style={
                        {
                            '--i': stackItems || 0,
                        } as React.CSSProperties
                    }
                >
                    <div className={`${styles.imgWrapperContent} ${styles.stackItemInner}`}>
                        <span className={styles.groupId}>{data.groupId}</span>
                        <img src={img} alt={''} />
                        <span>{name}</span>
                    </div>
                </div>
            </div>
            {/*<div className={styles.choice}>*/}
            <p>
                <span>Investment structure:</span>{' '}
                <span>
                    {(isOpen ? data.fund : collapsedFund || 'various').split('/').map((part, index, array) => (
                        <React.Fragment key={index}>
                            {part}
                            {index < array.length - 1 && (
                                <>
                                    <wbr />/<wbr />
                                </>
                            )}
                        </React.Fragment>
                    ))}
                </span>
            </p>
            <p>
                <span> Domicile:</span>
                <span>
                    {!isOpen && domicile?.toLowerCase() === 'various'
                        ? collapsedOpenDomicile
                        : Countries[
                              isOpen
                                  ? (data.domicile?.toLowerCase() as TCountryCode)
                                  : (domicile?.toLowerCase() as TCountryCode)
                          ]?.domicileName || collapsedOpenDomicile}
                </span>
            </p>
            <p>
                <span>Legal type: </span>
                <span>
                    {((isOpen ? data.legalType : collapsedLegalType) || '').split('/').map((part, index, array) => (
                        <React.Fragment key={index}>
                            {part}
                            {index < array.length - 1 && (
                                <>
                                    <wbr />/<wbr />
                                </>
                            )}
                        </React.Fragment>
                    ))}
                </span>
            </p>
            <p>
                <span>Open ended:</span>
                <span>
                    {!isOpen && (collapsedOpenEnded === 'various' || collapsedOpenEnded === 'any') ? (
                        collapsedOpenEnded
                    ) : (
                        <BooleanImage value={isOpen ? data.ifOpenEnded : collapsedOpenEnded === true} />
                    )}
                </span>
            </p>
            {/*</div>*/}
        </>
    );

    return (
        <>
            {/*// <div*/}
            {/*//     className={`${styles.link} ${isOpen ? styles.open : styles.closed} ${*/}
            {/*//         isSelecting ? `${styles.selecting} ${isSelected ? styles.selected : ''}` : ''*/}
            {/*//     }`}*/}
            {/*//     onClick={handleClick}*/}
            {/*// >*/}
            {/*{isSelecting && isSelected && (*/}
            {/*// <div className={styles.selectedCheck}>*/}
            {/*//     <BooleanImage value={true} />*/}
            {/*// </div>*/}
            {/*)}*/}

            {hasLink ? (
                <Link to={`/${link}`} className={styles.content}>
                    <Content
                        stackItems={stackItems}
                        data={data}
                        img={img}
                        name={name}
                        isOpen={isOpen}
                        collapsedOpenEnded={collapsedOpenEnded}
                        collapsedLegalType={collapsedLegalType}
                        collapsedFund={collapsedFund}
                        collapsedOpenDomicile={collapsedOpenDomicile}
                    />
                </Link>
            ) : (
                <div
                    className={`${styles.content}
                ${isSelecting ? `${styles.selecting} ${isSelected ? styles.selected : ''}` : ''}
                `}
                    onClick={handleClick}
                >
                    {isSelected && (
                        <div className={styles.selectedCheck}>
                            <BooleanImage value={true} />
                        </div>
                    )}

                    <Content
                        stackItems={stackItems}
                        data={data}
                        img={img}
                        name={name}
                        isOpen={isOpen}
                        collapsedOpenEnded={collapsedOpenEnded}
                        collapsedLegalType={collapsedLegalType}
                        collapsedFund={collapsedFund}
                        collapsedOpenDomicile={collapsedOpenDomicile}
                    />
                </div>
            )}
            {/*</div>*/}
        </>
    );
};

export default TaxBox;
